import script from "./Announcement.vue?vue&type=script&lang=ts&setup=true"
export * from "./Announcement.vue?vue&type=script&lang=ts&setup=true"

import "./Announcement.vue?vue&type=style&index=0&id=5b93bcd3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b93bcd3"]])

export default __exports__